<template>
  <div id="ssiAnalysis" class="animated fadeIn h-100">
    <b-row class="h-100">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-col style="flex: 0 0 20%; max-width: 20%" class="tree pr20">
        <b-card
          class="h-100 black-border1"
          body-class="h-100 p10"
          header-tag="header"
        >
          <h6 slot="header">차트 조회 옵션</h6>
          <b-form @submit.prevent="getData" class="chartOptions">
            <b-row>
              <b-col>
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  @input="getStidList"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  @input="onSelectedStr"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>날짜</label>
                <b-form-input
                  type="date"
                  v-model="search.date"
                  :max="search.maxDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row v-if="search.dataType === 'file'">
              <b-col>
                <label>시간</label>
                <b-form-select
                  v-model="search.selectedTime"
                  :options="search.times"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row v-if="search.sensorAxisType === '3'">
              <b-col>
                <label>축</label>
                <b-form-select
                  v-model="search.axisType"
                  :options="search.axisTypeOptions"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row style="margin-top: 20px">
              <b-col>
                <label>Target_freq_num</label>
                <b-form-input
                  v-model="search.targetFreqNum"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Fre_LowerBnd</label>
                <b-form-input
                  v-model="search.freLowerBnd"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Fre_UpperBnd</label>
                <b-form-input
                  v-model="search.freUpperBnd"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>FS</label>
                <b-form-input
                  v-model="search.fs"
                  required
                  disabled
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>SSI_Order</label>
                <b-form-input
                  v-model="search.ssiOrder"
                  required
                  disabled
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>SSI_X</label>
                <b-form-input
                  v-model="search.ssiX"
                  required
                  disabled
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <b-button class="full-searchBtn" type="submit">분석</b-button>
              </div>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col style="flex: 0 0 80%; max-width: 80%" class="cont">
        <b-row class="h-100 chartarea">
          <b-col class="col-12">
            <div class="h62 p15 searchBox mb15 border0">
              <div>
                <label class="pb2">진행상황</label>
                <div class="animated fadeIn prog" v-if="progress.rawfiledown">
                  <i class="fas fa-file-download mr10"></i>RAW FILE
                  다운로드<font
                    v-if="progress.rawfiledownfin"
                    class="ml10"
                    color="#22a75d"
                    ><i class="fas fa-check"></i
                  ></font>
                </div>
                <div class="animated fadeIn prog" v-if="progress.anal">
                  <i class="fas fa-arrow-right"></i>
                </div>
                <div class="animated fadeIn prog" v-if="progress.anal">
                  <i class="fas fa-wave-square mr10"></i>분석
                  <b-spinner
                    v-if="progress.anal && !progress.analfin"
                    class="h20 w20 ml15"
                    label="Loading..."
                  ></b-spinner>
                  <font v-if="progress.analfin" class="ml10" color="#22a75d"
                    ><i class="fas fa-check"></i
                  ></font>
                </div>
              </div>
            </div>
            <b-card
              class="hc-sub77 border0"
              body-class="h-100 p20"
              style="height: calc(100vh - 197px) !important; overflow-y: auto"
            >
              <b-row class="h-70">
                <b-col>
                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                  >
                    <h6 slot="header">
                      {{ rawChartTitle }}
                    </h6>
                    <div id="rawChart" class="graph"></div>
                  </b-card>
                </b-col>
              </b-row>
              <b-row class="h-30 pt10">
                <b-row class="w-100 pr10">
                  <b-col>
                    <ag-grid-vue
                      class="ag-theme-balham grid"
                      :gridOptions="gridOptions"
                    ></ag-grid-vue>
                  </b-col>
                </b-row>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
import { AgGridVue } from "ag-grid-vue";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AgGridVue,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getTreeGridApi",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getCenterBus",
    ]),
  },
  data() {
    return {
      chartConfig: {},
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        dataType: null,
        dataTypeOptions: [
          { value: null, text: "선택" },
          { value: "rawe", text: "RAWE" },
          { value: "file", text: "FILE" },
        ],
        date: null,
        maxDate: null,
        times: [],
        selectedTime: null,
        targetFreqNum: 1,
        freLowerBnd: 2,
        freUpperBnd: 20,
        fs: 100,
        ssiOrder: 30,
        ssiX: 13,
        sensorAxisType: null,
        axisType: null,
        axisTypeOptions: [
          { value: "0", text: "X" },
          { value: "1", text: "Y" },
          { value: "2", text: "Z" },
        ],
      },
      rawChartTitle: "RAW",
      rawChart: [],
      chart: {
        clearyn: false,
        data: [],
      },
      LoadYn: false,
      progress: {
        rawfiledown: false,
        rawfiledownfin: false,
        anal: false,
        analfin: false,
      },
      subscription: null,
      gridRowData: [],
      gridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "선택된 데이터가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        rowHeight: 35,
        headerHeight: 35,
      },
    };
  },
  created() {
    this.getProjectList();
  },
  beforeMount() {
    this.gridOptions.columnDefs = [
      { headerName: "idx", field: "idx", hide: true },
      { headerName: "Frequency", field: "f" },
      { headerName: "Damping", field: "c" },
    ];
    this.search.times = [];
    for (let i = 0; i <= 23; i++) {
      if (i < 10) {
        this.search.times.push("0" + i);
      } else {
        this.search.times.push("" + i);
      }
    }
    this.search.selectedTime = this.search.times[0];
  },
  mounted() {
    this.search.date = moment().add(-1, "day").format("YYYY-MM-DD");
    this.search.maxDate = moment().add(-1, "day").format("YYYY-MM-DD");

    if (this.getSelectedDataStartDate) {
      this.search.date = this.getSelectedDataStartDate;
    }
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
    ]),
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectListAll", reqBody) // HICC230608
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            const projst = {
              PRE: "(준비중)",
              SVC: "",
              IDL: "(휴면)",
              EXP: "(종료)",
            };
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname + projst[data[i].projstate],
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
                this.search.dataType = "file";
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onSelectedStr() {
      if (this.search.stid) {
        this.getAxisType(this.search.stid);
        this.getFS();
      }
    },
    getFS() {
      this.search.dataType = "file";

      let reqBody = {
        stid: this.search.stid,
      };

      this.$http
        .post("/ssiAnalysis/getFS", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.search.fs = res.data.data;
          } else {
            this.setAlertTitle("FS 데이터 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAxisType(structureId) {
      this.$http
        .post("/ssiAnalysis/getAxisType", { structureId: structureId })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            if (res.data.data && res.data.data.hasOwnProperty("axis")) {
              let axisArray = JSON.parse(res.data.data.axis);
              if (axisArray.includes("1")) {
                this.search.sensorAxisType = "1";
                if (axisArray.includes("2") || axisArray.includes("3")) {
                  this.search.sensorAxisType = "3";
                }
              }

              if (this.search.sensorAxisType === "1") {
                this.search.axisType = null;
              } else if (this.search.sensorAxisType === "3") {
                this.search.axisType = "2";
              }
            }
          } else {
            this.setAlertTitle("센서 축 정보 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getData() {
      if (this.search.stid === null && this.search.dataType === null) return;

      var reqBody = {
        stid: this.search.stid,
        date: moment(this.search.date).format("YYYYMMDD"),
        time: this.search.selectedTime,
        Target_Freq_Num: this.search.targetFreqNum,
        Fre_lowerBnd: this.search.freLowerBnd,
        Fre_UpperBnd: this.search.freUpperBnd,
        FS: this.search.fs,
        SSI_order: this.search.ssiOrder,
        SSI_x: this.search.ssiX,
        axis: this.search.axisType,
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.date);

      this.LoadYn = true;
      this.initData();

      this.$http
        .post("/ssiAnalysis/getSSIOctData", reqBody, { timeout: 60000 })
        .then((res) => {
          this.LoadYn = false;
          if (res.data.resultyn === "Y") {
            const rowData = [];
            const freq = res.data.data.result[0].c;
            const damp = res.data.data.result[0].f;

            for (var i = 0; i < freq.length; i++) {
              rowData.push({ c: freq[i], f: damp[i] });
            }

            this.gridOptions.api.setRowData(rowData);

            const chartData = res.data.data.sensor_data.y;

            for (var i = 0; i < chartData.length; i++) {
              this.rawChart.push({
                y: chartData[i].data,
                name: chartData[i].name,
                type: "scatter",
                mode: "lines",
                line: { width: 1 },
              });
            }
            this.drawChart("rawChart", this.rawChart);
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk(res.data.errormsg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    initData() {
      this.gridOptions.api.setRowData([]);
      this.gridRowData = [];
      this.rawChart = [];

      Plotly.purge("rawChart");
    },
    drawChart(id, dataArr) {
      var data = dataArr;
      var layout = chartUtil.setDefaultLayout(id);
      layout.margin = {
        l: 80,
        r: 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = false;
      Plotly.newPlot(id, data, layout);
    },
  },
};
</script>

<style lang="scss">
#ssiAnalysis {
  padding: 15px;
  & .chartOptions {
    height: calc(100vh - 187px);
    overflow-y: auto;
    & .row {
      height: 50px;
      & .col {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        & label {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #b4b7bd;
          width: 120px;
          height: 100%;
          margin-bottom: 0;
        }
        & input,
        & select {
          width: 200px;
        }
      }
    }
  }
  & .rawe-progress {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: rgba(6, 6, 6, 0.3);
    & > div.progress {
      position: relative;
      top: calc(50% - 15px);
      width: 400px;
      height: 30px;
      left: calc(50% - 200px);
    }
  }
  & .searchBox {
    justify-content: space-between;
    border-radius: 5px;
    & > div:first-child {
      & > label {
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 16px;
      }
    }
    & .prog {
      display: flex;
      align-items: center;
      height: 100%;
      color: #fff;
      font-size: 16px;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    & .custom-checkbox {
      & > input[type="checkbox"] {
        width: 140px;
      }
      & > label {
        display: flex;
        align-items: center;
        justify-content: center;
        &.custom-control-label {
          &::before,
          &::after {
            top: 7px;
            left: -20px;
          }
        }
      }
    }
  }
  & .chartarea {
    & .card {
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #404656;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: 100%;
        }
      }
    }
  }
  & div.ag-theme-balham.grid {
    height: calc(100% - 60px) !important;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
  & .mode-shape-btn {
    width: 150px;
    height: 100%;
    border: 1px solid;
    border-color: #f1f1f1;
    border-radius: 5px;
    background-color: #ffffff54;
    color: #fff;
  }
  & .mode-shape-btn:hover {
    border-color: #6349f3;
  }
  & .mode-shape-btn:disabled {
    border-color: #1b1b1b;
    background-color: #00000096;
  }
  & .model-shape-type-1 {
    background-image: url("../../../static/img/shapeModelType_1.png");
    background-position: center center;
    background-repeat: no-repeat;
  }
  & .model-shape-type-2 {
    background-image: url("../../../static/img/shapeModelType_2.png");
    background-position: center center;
    background-repeat: no-repeat;
  }
  & .model-shape-type-3 {
    background-image: url("../../../static/img/shapeModelType_3.png");
    background-position: center center;
    background-repeat: no-repeat;
  }
  & .shape-play-btn {
    color: #fff;
    background-color: transparent;
    margin-bottom: 5px;
  }
  & .shape-play-btn:disabled {
    color: #555;
    background-color: #0000003b;
    margin-bottom: 5px;
  }
  .select-container {
    .vs__dropdown-toggle {
      width: 200px;
      height: 35px;
      margin-right: 0px;
    }
    // .vs__search::placeholder {
    //   color: #b4b7bd !important;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/SsiAnalysisOctave.vue